/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

import Footer from "./footerAppendix";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Dropdown from "./dropdown";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  background: "#ddeff3",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px " }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th
      {...rest}
      style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400, fontSize: "14px" }}
    >
      {children}
    </th>
  );
};
const defaultOption = [
  {
    value: "title",
    label: "title",
    disabled: true,
  },
];

const billIDOption = [
  {
    value: "01GTKT",
    label: "01GTKT",
    disabled: false,
  },
  {
    value: "02GTTT",
    label: "02GTTT",
    disabled: false,
  },
  {
    value: "07KPTQ",
    label: "07KPTQ",
    disabled: false,
  },
  {
    value: "03XKNP",
    label: "03XKNP",
    disabled: false,
  },
  {
    value: "04HGDL",
    label: "04HGDL",
    disabled: false,
  },
  {
    value: "01BHDT",
    label: "01BHDT",
    disabled: false,
  },
  {
    value: "01/",
    label: "01/",
    disabled: false,
  },
  {
    value: "02/",
    label: "02/",
    disabled: false,
  },
  {
    value: "TT120",
    label: "TT120",
    disabled: false,
  },
  {
    value: "01TEDB",
    label: "01TEDB",
    disabled: false,
  },
  {
    value: "01VEDB",
    label: "01VEDB",
    disabled: false,
  },
  {
    value: "01THDB",
    label: "01THDB",
    disabled: false,
  },
  {
    value: "02TEDB",
    label: "02TEDB",
    disabled: false,
  },
  {
    value: "02VEDB",
    label: "02TEDB",
    disabled: false,
  },
  {
    value: "02THDB",
    label: "02TEDB",
    disabled: false,
  },
];

const formBillOption = [
  {
    value: "T",
    label: "T",
    disabled: false,
  },
  {
    value: "P",
    label: "P",
    disabled: false,
  },
  {
    value: "E",
    label: "E",
    disabled: false,
  },
];

const content = {
  item1: [
    {
      new: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      billId: {
        type: "select",
        value: null,
        bg: false,
        option: billIDOption,
      },
      billName: {
        type: "input",
        value: null,
        bg: false,
      },
      denominatorBill: {
        type: "input",
        value: null,
        bg: false,
      },
      symbolBill: {
        type: "input",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: true,
      },
      from: {
        type: "input",
        value: null,
        bg: false,
      },
      to: {
        type: "input",
        value: null,
        bg: false,
      },
    },
  ],
  item2: [
    {
      new: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      billId: {
        type: "select",
        value: null,
        bg: false,
        option: billIDOption,
      },
      billName: {
        type: "input",
        value: null,
        bg: false,
      },
      denominatorBill: {
        type: "input",
        value: null,
        bg: false,
      },
      symbolBill: {
        type: "input",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: true,
      },
      from: {
        type: "input",
        value: null,
        bg: false,
      },
      to: {
        type: "input",
        value: null,
        bg: false,
      },
    },
  ],
};
export default function Table3_12({ formData, setFieldValue }) {
  const [data, setData] = useState(content);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { type: item[name]?.type, value } };
        }
        return item;
      }),
    }));
  };

  const addNewRow = (item) => {
    const newRow = {
      id: {
        value: uuidV4(),
        bg: true,
      },
      billId: {
        type: "select",
        value: null,
        option: billIDOption,
        bg: false,
      },
      billName: {
        type: "input",
        value: null,
        bg: false,
      },
      denominatorBill: {
        type: "input",
        value: null,
        bg: false,
      },
      symbolBill: {
        type: "input",
        value: null,
        bg: false,
      },
      quantity: {
        type: "input",
        value: 0,
        bg: true,
      },
      from: {
        type: "input",
        value: null,
        bg: false,
      },
      to: {
        type: "input",
        value: null,
        bg: false,
      },
    };
    setData((prev) => ({ ...prev, [item]: [...prev[item], newRow] }));
  };

  const handleDelete = (type, index) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type].filter((item) => item.id.value !== index),
    }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
          3 Các loại hóa chưa sử dụng
        </Typography>
      </Grid>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Mã hóa đơn</Th>
              <Th style={{ textAlign: "center", width: "150px" }}>Tên loại hóa đơn</Th>
              <Th style={{ textAlign: "center" }}>Mẫu số</Th>
              <Th style={{ textAlign: "center" }}>Ký hiệu hóa đơn</Th>
              <Th style={{ textAlign: "center" }}>Số lượng</Th>
              <Th style={{ textAlign: "center" }}>Từ số</Th>
              <Th style={{ textAlign: "center" }}>Đến số</Th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <Td
                row={""}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
                className="toggle-button"
              >
                I
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                row={""}
                colSpan={7}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                HÓA ĐƠN HẾT GIÁ TRỊ SỬ DỤNG
              </Td>
            </tr>
            {data &&
              data.item1.length > 0 &&
              data.item1.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    className="toggle-button"
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index + 1}
                    {!row.new && (
                      <div className="button-action delete">
                        <button type="button" onClick={() => handleDelete("item1", row.id.value)}>
                          Xóa dòng
                        </button>
                      </div>
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.billId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billId.bg ? (
                      row.billId.value
                    ) : row.billId?.type === "select" ? (
                      <SelectTable
                        name="billId"
                        rowType={"item1"}
                        id={row.id.value}
                        option={billIDOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        id={row.id.value}
                        name="billId"
                        value={row.billId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.billName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billName?.type !== "input" ? (
                      row.billName.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"text"}
                        id={row.id.value}
                        name="billName"
                        value={row.billName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.denominatorBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.denominatorBill?.type !== "input" ? (
                      row.denominatorBill.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"text"}
                        id={row.id.value}
                        name="denominatorBill"
                        value={row.denominatorBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.symbolBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.symbolBill?.type !== "input" ? (
                      row.symbolBill.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"text"}
                        id={row.id.value}
                        name="symbolBill"
                        value={row.symbolBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"number"}
                        id={row.id.value}
                        name="quantity"
                        value={row.quantity.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.from.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.from?.type !== "input" ? (
                      row.from.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"number"}
                        id={row.id.value}
                        name="from"
                        value={row.from.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.to.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.to?.type !== "input" ? (
                      row.to.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"number"}
                        id={row.id.value}
                        name="to"
                        value={row.to.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                className="toggle-button"
                row={""}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                II
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item2")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                row={""}
                colSpan={7}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                HÓA ĐƠN ĐĂNG KÝ TIẾP TỤC SỬ DỤNG
              </Td>
            </tr>
            {data &&
              data.item2.length > 0 &&
              data.item2.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    className="toggle-button"
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index + 1}
                    {!row.new && (
                      <div className="button-action delete">
                        <button type="button" onClick={() => handleDelete("item2", row.id.value)}>
                          Xóa dòng
                        </button>
                      </div>
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.billId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billId.bg ? (
                      row.billId.value
                    ) : row.billId?.type === "select" ? (
                      <SelectTable
                        name="billId"
                        rowType={"item2"}
                        id={row.id.value}
                        option={billIDOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        id={row.id.value}
                        name="billId"
                        value={row.billId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.billName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.billName?.type !== "input" ? (
                      row.billName.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        type={"text"}
                        id={row.id.value}
                        name="billName"
                        value={row.billName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.denominatorBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.denominatorBill?.type !== "input" ? (
                      row.denominatorBill.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        type={"text"}
                        id={row.id.value}
                        name="denominatorBill"
                        value={row.denominatorBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.symbolBill.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.symbolBill?.type !== "input" ? (
                      row.symbolBill.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        type={"text"}
                        id={row.id.value}
                        name="symbolBill"
                        value={row.symbolBill.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantity.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantity?.type !== "input" ? (
                      row.quantity.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        type={"number"}
                        id={row.id.value}
                        name="quantity"
                        value={row.quantity.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.from.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.from?.type !== "input" ? (
                      row.from.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        type={"number"}
                        id={row.id.value}
                        name="from"
                        value={row.from.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.to.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.to?.type !== "input" ? (
                      row.to.value
                    ) : (
                      <InputTable
                        rowType={"item2"}
                        type={"number"}
                        id={row.id.value}
                        name="to"
                        value={row.to.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                colspan="3"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type, rowType });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name, type, rowType });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, rowType, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
